<template>
    <div class="industry-slider-item">
        <div class="industry-slider-img mr-spc33 relative">
            <img :src="industries.img" alt="Industry">
            <div class="title-overlay absolute left-0 bottom-0 h-40 w-full flex items-end pl-spc34 pb-spc34">
                <h2 class="text-xl leading-spc7 font-bold text-white">
                    {{industries.title}}
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IndustrySlider",
        props: ['industries']
    }
</script>

<style scoped>

</style>